import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Caliber = () => {
  return (
    <div className="caliber-section  ">
      <Container className=" ">
        <Row className="align-items-center ">
          <Col xs={12} md={6} className="video-section order-2 order-md-1">
            <div className="video-placeholder hackathon-image">
              <img
                src="../../../images/recruiters/group-101.jpg"
                alt="Chris Jackson"
                className="expert-img"
              />
            </div>
          </Col>
          {/* Left Side: Text Content */}
          <Col xs={12} md={6} className="caliber-text  order-1 order-md-2">
            <p className="caliber-subtitle">Improve student placements</p>
            <h2 className="caliber-title">
              Why Universities Across the World Choose CLIF AI
            </h2>
            <span className="accelerate-subtitle">
              <li>No complex setup</li>
              <li>Affordable for colleges of all sizes</li>
              <li>Works on mobile and desktop</li>
              <li>Placement Readiness Programs</li>
              <li>Already trusted by major universities and 5000+ students</li>
              <li> Improve student placements</li>
              <li> Attract more admissions</li>
              <li> Become known for career support and innovation</li>
            </span>
          </Col>

          {/* Right Side: Image Placeholder */}
        </Row>
      </Container>
    </div>
  );
};

export default Caliber;
